import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../services/queryClient';

/**
 * HOC that wraps a component with all shared React providers.
 * Use this in every react2angular registration for components that need
 * TanStack Query or other provider-backed features.
 */
export function withProviders<P extends object>(
  Component: React.ComponentType<P>
): React.ComponentType<P> {
  return function WithProviders(props: P) {
    return (
      <QueryClientProvider client={queryClient}>
        <Component {...props} />
      </QueryClientProvider>
    );
  };
}
